<h1 mat-dialog-title>{{ 'page.items.chooseStatusTitle' | translate }}</h1>

<div mat-dialog-content class="ksc-content">
  <p class="ksc-hint">
    {{ 'page.items.chooseStatusHint' | translate: { key: data.itemKey, item: data.itemTitle } }}
  </p>

  <div class="ksc-options">
    <button *ngFor="let step of stepChoices" type="button" class="ksc-option" (click)="dialogRef.close(step.id)">
      <app-status-category-badge
        [statusCategory]="step.statusCategory"
        [label]="step.label"
      ></app-status-category-badge>
    </button>
  </div>
</div>

<mat-dialog-actions align="end">
  <button matButton="tonal" (click)="dialogRef.close(undefined)">{{ 'button.cancel' | translate }}</button>
</mat-dialog-actions>
